import React, { useState } from 'react';

const SEGMENTS = [
  { color: '#ef4444', label: '1 - Muy deficiente' },
  { color: '#f97316', label: '2 - Deficiente' },
  { color: '#f59e42', label: '3 - Mejorable' },
  { color: '#22c55e', label: '4 - Bueno' },
  { color: '#0ea5e9', label: '5 - Excelente' }
];

export default function EstadoGeneralThermometer({ estadoGeneral }) {
  const [hoveredIdx, setHoveredIdx] = useState(null);
  return (
    <div className="mb-8">
      <span className="font-semibold text-gray-700">Estado general (1-5):</span>
      <span
        className="inline-block align-middle ml-2 text-blue-500 cursor-pointer"
        title={
          'Valoración IA del estado general:\n' +
          '1–2: Muy deficiente · 3: Mejorable · 4: Bueno · 5: Excelente'
        }
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="white" />
          <text x="12" y="16" textAnchor="middle" fontSize="12" fill="currentColor">i</text>
        </svg>
      </span>
      <div className="flex flex-col items-stretch mt-2">
        {/* Number above arrow */}
        <div className="flex flex-row w-full mb-0" style={{height: '20px'}}>
          {Array(5).fill(0).map((_, idx) => (
            <div key={idx} className="flex-1 flex justify-center items-end">
              {estadoGeneral === idx + 1 && (
                <span className="text-blue-700 text-lg font-bold" style={{marginBottom: '-2px'}}>{estadoGeneral}</span>
              )}
            </div>
          ))}
        </div>
        {/* Arrow row */}
        <div className="flex flex-row w-full mb-1" style={{height: '18px'}}>
          {Array(5).fill(0).map((_, idx) => (
            <div key={idx} className="flex-1 flex justify-center items-end">
              {estadoGeneral === idx + 1 && (
                <span className="text-blue-700 text-lg" style={{marginBottom: '-2px'}}>▼</span>
              )}
            </div>
          ))}
        </div>
        {/* Colored bar with 1 and 5 */}
        <div className="flex items-center relative" style={{ minHeight: '40px' }}>
          <span className="text-xs text-gray-500 font-bold mr-2">1</span>
          <div className="flex-1 flex h-4 rounded-full overflow-visible relative">
            {/* Tooltip above the bar, positioned over the hovered segment */}
            {hoveredIdx !== null && (
              <div
                className="absolute z-10 -top-10 left-0 w-full flex"
                style={{ pointerEvents: 'none' }}
              >
                {SEGMENTS.map((seg, idx) => (
                  <div key={idx} className="flex-1 flex justify-center">
                    {hoveredIdx === idx && (
                      <div className="relative px-3 py-1 bg-gray-900 text-white text-xs rounded shadow-lg whitespace-nowrap">
                        {seg.label}
                        <div className="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-gray-900"></div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
            {/* Colored segments */}
            {SEGMENTS.map((seg, idx) => (
              <div
                key={idx}
                className={`flex-1 h-4 transition-all duration-300 cursor-pointer border border-white`}
                style={{ background: seg.color }}
                onMouseEnter={() => setHoveredIdx(idx)}
                onMouseLeave={() => setHoveredIdx(null)}
              ></div>
            ))}
          </div>
          <span className="text-xs text-gray-500 font-bold ml-2">5</span>
        </div>
      </div>
    </div>
  );
} 